import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'
import {ParcelWithPositionsData} from '../Pages/OrderDetails/Parcels/ParcelsState'

export function create(data: ParcelWithPositionsData): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/parcels`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data),
    }
}

export function delete_(
    id: number,
): HttpRequest {
    return {
        verb: 'DELETE',
        url: `${server}/parcels/${id}`,
        headers: {
            Accept: 'Application/json'
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/ParcelResource.ts